import { renderAlert } from "../../CommonComponents/Alert/Alert";
import {  PATCH, POST } from "../../service/axiosMethods"
import { ELASTIC_URL } from "../../utils/apiConstant"
import store from "../store";
import ACTION_TYPES from "../types";
import { v4 as uuidv4 } from 'uuid'
import {  createSheetHelperForWorkSpaces,  internallySortSheetDocObj,  navigateToMyWorkbooks, navigateToMyWorkbooksIfSharedSheetNotFound, removeLockFromSheet, updateSheetReducerIfSheetFoundDeleted } from "./sheetAction";
import { getWorkbooksSyncedWIthOneDrive, updateAccessInStore } from "./userActivityAction";
import { handleEmptySheetList } from "../../pages/Sheet/helper/OptimizedSheetHelper";
import { returnSharedWorkbookObject } from "../../MiniProducts/xTables/helper/helperFunctions";
import { deleteTemplate } from "./templateAction";
import { sendMail } from "../../helpers/mailHelper";
import { getWorkspaceWorkbookAndSharedSheets } from "../../helpers/helper";

export const getWorkbookListByUserId = (userFromDb, addWorkbook, navigateToSheetCallback, preDefinedWorkbook, setWbInStore = true) => async (dispatch) => {
    try {
        if (!userFromDb.email) return

        const res = await POST(`${ELASTIC_URL}/search`, {
            index: 'workbook',
            field: "user_id",
            value: `${userFromDb.email}`
        });

        const { workspaceWorkbookData } = await getWorkspaceWorkbookAndSharedSheets(userFromDb);

        let workbookIdListFromDB = [];
        let allWorkbooks = [];

        if (res && res.status == 201) {
            res.data.forEach((workbook) => {

                if (
                    workbook._source.id &&
                    workbook._id &&
                    workbook._source.id !== workbook._id
                ) return;

                const wb = {
                    index: workbook._index,
                    id: workbook._id,
                    ...workbook._source
                };

                // 🔥 Ensure workspace_id exists (backward compatibility)
                if (!wb.workspace_id) {
                    wb.workspace_id = "myWorkspace";
                }

                workbookIdListFromDB.push(workbook._id);
                allWorkbooks.push(wb);
            });

            if (workspaceWorkbookData?.length) {
                workspaceWorkbookData.forEach((wb) => {
                    const formattedWb = {
                        id: wb.id,
                        index: "workbook",
                        ...wb,
                    };

                    workbookIdListFromDB.push(wb.id);
                    allWorkbooks.push(formattedWb);
                });
            }

            const workbookMap = new Map();
            allWorkbooks.forEach((wb) => {
                workbookMap.set(wb.id, wb);
            });

            const mergedWorkbooks = Array.from(workbookMap.values());

            if (!mergedWorkbooks.length) {
                dispatch({
                    type: ACTION_TYPES.GET_WORKBOOK_DATA,
                    workbookListData: [],
                    currentSelectedWorkbook: null,
                    selectedWorkbookId: "",
                    isWorkbookListDataFetched: true,
                });

                if (addWorkbook) addWorkbook();
                return;
            }

            let selectedWorkbook;

            if (preDefinedWorkbook) {
                selectedWorkbook = allWorkbooks.find(
                    wb => wb.id === preDefinedWorkbook
                );
            }

            if (!selectedWorkbook) {
                selectedWorkbook = allWorkbooks[0];
            }


            if (setWbInStore){
                dispatch({
                    type: ACTION_TYPES.GET_WORKBOOK_DATA,
                    workbookIdListFromDB,
                    workbookListData: mergedWorkbooks,
                    currentSelectedWorkbook: selectedWorkbook || null,
                    selectedWorkbookId: selectedWorkbook?.id ?? '',
                    isWorkbookListDataFetched: true
                });
            }else{
                dispatch({
                    type: ACTION_TYPES.SET_IS_WORKBOOKDATAFETCHED,
                    workbookListData: mergedWorkbooks,
                    workbookIdListFromDB,
                    isWorkbookListDataFetched: true
                });
            }
            if (navigateToSheetCallback) navigateToSheetCallback(selectedWorkbook)
            if (workbookIdListFromDB.length) dispatch(getWorkbooksSyncedWIthOneDrive(workbookIdListFromDB))
        }
    } catch (error) {
        console.log(error)
    }
}

export const setSharedWbOnRefresh = (workbookId, sheetId, navigate, userData, callback) => async (dispatch) => {
    try {
        let sheetIdListFromDb = [];
        let sheetList = []
        let sheetDocObj = {}
        let wbObject = await dispatch(returnSharedWorkbookObject(workbookId, userData, sheetList));

        const sheetIndex = window.SHEET_INDEX;
        const res = await POST(`${ELASTIC_URL}/sheet/searchByWorkbookId`, { index: sheetIndex, workbook_id: `${workbookId}`, loggedInUser:`${userData.email}` });
        if (res.data.length === 0) {
            const isWbDeactivated = await getDeactivatedWorkbooks([`${workbookId}`]);
            if (isWbDeactivated.length > 0) {
                renderAlert("Workbook has been deleted, Redirecting to My Workbooks", 'error', 2000);
                dispatch(navigateToMyWorkbooksIfSharedSheetNotFound(navigate, true));
                return;
            }
        }

        if (res) {
            res && res.data && res.data.length && res.data.forEach((sheet) => {
                if (sheet._source.workbook_id === workbookId) {
                    if (!sheet._source.sheet_identifier || (sheet._source.sheet_identifier && sheet._source.pageNo === 1)) {
                        let obj = { index: sheet._index, id: sheet._id, columnDefs: sheet._source.columns, ...sheet._source }
                        sheetList.push(obj)
                        sheetIdListFromDb.push(sheet._id);
                        localStorage.setItem('mD_' + sheet._id, JSON.stringify({ name: sheet._source.name, wb_name: wbObject.name, loggedInUser: userData.email, sheetOwner: sheet._source.user_email }))
                        localStorage.setItem('mD_' + sheet._source.sheet_identifier, JSON.stringify({ name: sheet._source.name, wb_name: wbObject.name, loggedInUser: userData.email, sheetOwner: sheet._source.user_email }))
                    }
                    if (sheetDocObj[sheet._source.sheet_identifier]) sheetDocObj[sheet._source.sheet_identifier].push({ id: sheet._id, ...sheet._source })
                    else sheetDocObj[sheet._source.sheet_identifier] = [{ id: sheet._id, ...sheet._source }]
                }
            })
            sheetList.forEach((sheet) => {
                if (sheet.copyOfOriginal) {
                    sheet.l_id = "sharedTemplates" + "." + sheet.parent + sheet.id
                    delete sheet.workspace_id
                }
            })
            let sortedSheetDocObj=internallySortSheetDocObj(sheetDocObj)
            wbObject.sheetList = sheetList;
            dispatch({ type: ACTION_TYPES.SET_WORKBOOK_DATA, currentSelectedWorkbook: wbObject, selectedWorkbookId: workbookId })
            dispatch({ type: ACTION_TYPES.GET_SHEET_DATA, payload: sheetList, itemId: sheetIdListFromDb, sheetDocObj: sortedSheetDocObj })

            let selectedSheet
            if(sheetId){
                selectedSheet=sheetList.filter((sheet)=>sheet.id===sheetId)
                if(selectedSheet.length > 0) {
                    selectedSheet=selectedSheet[0]
                }
                else selectedSheet=sheetList[0]
            }
            else selectedSheet=sheetList[0]

            setTimeout(() => {
                
            }, 500);

            if(callback)callback(sheetList, selectedSheet)
        }

    } catch (error) {
        console.error("Error in setSharedWbOnRefresh", error);

    }
}

export const deleteWorkbook = (workbook, callback, isDeleteWorkspace, updateSidebar=true) => async (dispatch) => {
    try {
        let id = workbook.id
        const res = await POST(`${ELASTIC_URL}/workbook/delete`, { id: workbook.id, 'user_email': workbook.user_email })
        if (res) {
            let { workbookListData } = store.getState().workbookReducer
            let restOfTheWorkbooks = workbookListData.filter(wb => wb.id !== workbook.id)
            dispatch({ type: ACTION_TYPES.DELETE_WORKBOOK_ITEM, payload: workbook })

            if(updateSidebar)
            setTimeout(() => {
                dispatch({ type: ACTION_TYPES.SET_WORKSPACE_DATA, rowDataEditor: { action: "deleteWorkbook", workbook: { id: workbook.id } } })
            }, 100);
            if (!isDeleteWorkspace) {
                setTimeout(() => {
                    if (workbook.copyOfOriginal) {
                        const deleteTemplateWB = workbookListData.find(wb => wb.id == workbook.id);
                        dispatch(deleteTemplate(deleteTemplateWB));
                    }
                    renderAlert('Workbook deleted', 'success')
                }, 100);
            }

            if (callback) callback(restOfTheWorkbooks)
        }
    } catch (error) {
        console.log("error in deleteing workbook", error)
        renderAlert('Error in deleting workbook', 'error')
    }
}

export const getDeactivatedWorkbooks = async (workbookIds) => {
    try {
        let res = await POST(`${ELASTIC_URL}/workbook/returnActivatedAndDeactivatedWorkbooks`, { workbookIds: workbookIds })
        if (res && res.data) {
            return res.data.deactivated
        }
    }
    catch (e) {
        console.error("Error in getting deactivated sheets", e)
        return []
    }

}

const handleExistingWorkbookUpdate = (workbookListCopy, currentSelectedWorkbook, newWorkbookFromDB, newWorkbookObject, existingWorkbookIndex, isCurrentSelectedWorkbook, callbackWhenWorbookIsUpdated) => async (dispatch) => {
    let { currentDownladingWorkbook, exportWorkbook, isSharedWorkbook, workbookListData} = store.getState().workbookReducer;
    const { takeOneDriveBackup } = store.getState().userActivityReducer;
    const { sheetListData } = store.getState().sheetReducer;
    const isExportingAlreadyOngoing = (takeOneDriveBackup && ((currentDownladingWorkbook && Object.keys(currentDownladingWorkbook).length > 0) || (exportWorkbook && Object.keys(exportWorkbook).length > 0)));
    let oldWb = workbookListCopy[existingWorkbookIndex];
    const isWbNameChanged = currentSelectedWorkbook.name !== newWorkbookObject.name;
    let updatedWb = currentSelectedWorkbook?.id === newWorkbookFromDB._id ? {
        ...oldWb,
        name: newWorkbookObject.name ? newWorkbookObject.name : oldWb.name,
        sheetList: sheetListData
    } : { ...oldWb, name: newWorkbookObject.name ? newWorkbookObject.name : oldWb.name };

    workbookListCopy[existingWorkbookIndex] = updatedWb;

    if (isCurrentSelectedWorkbook) {
        await dispatch({ type: ACTION_TYPES.SET_WORKBOOK_DATA, 
            workbookListData: workbookListCopy , 
            selectedWorkbookId: newWorkbookFromDB._id, 
            currentSelectedWorkbook: { ...currentSelectedWorkbook, name: updatedWb.name } 
        })
    }
    else {
        await dispatch({ type: ACTION_TYPES.SET_WORKBOOK_DATA,workbookListData: workbookListCopy })
    }
    if(isWbNameChanged)
    dispatch({ type: ACTION_TYPES.SET_WORKSPACE_DATA, rowDataEditor: { action: "renameWorkbook", workbook: { name: updatedWb.name, id: updatedWb.id } } })
    if (callbackWhenWorbookIsUpdated && !isExportingAlreadyOngoing || callbackWhenWorbookIsUpdated) callbackWhenWorbookIsUpdated(updatedWb);
    return ;

}

const updateWorkbookInWorkbookReducerAfterSheetNotFound = (sheet, currentSelectedWorkbook,isSharedWorkbook) => async(dispatch) =>{
    try {
        
        const {sharedWithMeWorkBooks, workbookListData} = store.getState().workbookReducer;
        const {sheetListData}=store.getState().sheetReducer;
        if(isSharedWorkbook){
            const updatedSheetList = currentSelectedWorkbook.sheetList ? 
            currentSelectedWorkbook.sheetList.filter(sheetInWb => sheetInWb.id !== sheet.id) : 
            sheetListData.filter(sheetInWb => sheetInWb.id !== sheet.id);

            const updatedWokbook = {
                ...currentSelectedWorkbook,
                sheetList : updatedSheetList
            }
            const updatedWokBookList = sharedWithMeWorkBooks.map((wb) => {
                return wb.id === currentSelectedWorkbook.id? updatedWokbook : wb
            })

            dispatch({ type: ACTION_TYPES.SET_WORKBOOK_DATA , 
                sharedWithMeWorkBooks : updatedWokBookList, 
                currentSelectedWorkbook : updatedWokbook,
                isSharedWorkbook : true
            })

        }else{
            const updatedSheetList = currentSelectedWorkbook.sheetList ? 
            currentSelectedWorkbook.sheetList.filter(sheetInWb => sheetInWb.id !== sheet.id) : 
            sheetListData.filter(sheetInWb => sheetInWb.id !== sheet.id);

            const updatedWokbook = {
                ...currentSelectedWorkbook,
                sheetList : updatedSheetList
            }
            const updatedWokBookList = workbookListData.map((wb) => {
                return wb.id === currentSelectedWorkbook.id? updatedWokbook : wb
            })
            dispatch({ type: ACTION_TYPES.SET_WORKBOOK_DATA , 
                workbookListData : updatedWokBookList, 
                currentSelectedWorkbook : updatedWokbook,
                isSharedWorkbook : false
            })

        }

    } catch (error) {
        console.log("Error in updateWorkbookInWorkbookReducerAfterSheetNotFound", error);
        
    }
}

export const updateSharedWbInStoreIfWbDeleted = (workbookId, navigate, redirectToMyWbs=true, onlyUpdateTheWorkbook=false) =>async(dispatch) =>{
    try {
        const { sharedWithMeWorkBooks } = store.getState().workbookReducer;
        const { userData } = store.getState().userReducer;
        const { currentSelectedSheet } = store.getState().sheetReducer;

        if(currentSelectedSheet && !onlyUpdateTheWorkbook){
        await removeLockFromSheet(currentSelectedSheet.id)
        dispatch(setIsSharedWorkbookFlag(false));
    }
        const updatedSharedWithMeWorkBooks = sharedWithMeWorkBooks.filter(
            (wb) => wb.id!== workbookId
        );
        
        dispatch({ type: ACTION_TYPES.SET_SETSHAREDWITHMEWORKBOOKS , 
            sharedWithMeWorkBooks : updatedSharedWithMeWorkBooks, 
        })
        const accessKey = `${userData.email}_${workbookId}`;
        dispatch(updateAccessInStore(accessKey));
        dispatch({ type: ACTION_TYPES.SET_WORKSPACE_DATA, rowDataEditor: {action:"deleteWorkbook",workbook:{id:workbookId}}})

        if(redirectToMyWbs)
        dispatch(navigateToMyWorkbooks(false, navigate));
    } catch (error) {
        console.log("Error in updateSharedWbInStoreIfWbDeleted", error);
        
    }
}

export const updateWorkbookInStoreAfterSheetNotFound = (
    sheet,
    currentSelectedWorkbook, 
    isSharedWorkbook, 
    navigate,
    selectSheet, 
    callback
    ) => async(dispatch) =>{
    try {
        
        // for shared Wb 
        if(isSharedWorkbook){
            dispatch(updateWorkbookInWorkbookReducerAfterSheetNotFound(sheet ,currentSelectedWorkbook, true));
           dispatch(updateSheetReducerIfSheetFoundDeleted(sheet, async(sheet, sheetList, isEmptySheetList, workbookId) => {
            if (sheet) {
              selectSheet(sheet);
            } else {
                const deactivated = await getDeactivatedWorkbooks([workbookId]);
                if (deactivated.length > 0) {
                    renderAlert("Workbook deleted, redirecting to My Workbooks ","error",2000)
                    dispatch(updateSharedWbInStoreIfWbDeleted(workbookId, navigate, true))
                    dispatch(navigateToMyWorkbooksIfSharedSheetNotFound(navigate, true))
                    return
                } else {
                    handleEmptySheetList(
                        isEmptySheetList,
                        dispatch,
                        currentSelectedWorkbook,
                        navigate
                    );
                }

            }

            if (!sheet) navigate("/home");

            if (callback) callback();
          }))
        }else{
                // for normal sheets 
                dispatch(updateWorkbookInWorkbookReducerAfterSheetNotFound(sheet ,currentSelectedWorkbook, false));
                dispatch(updateSheetReducerIfSheetFoundDeleted(sheet, async(sheet, sheetList, isEmptySheetList) => {
                    if (sheet) {
                      selectSheet(sheet);
                    } else {
                        const checkIfWbHasBeenDeactivated = await getDeactivatedWorkbooks([currentSelectedWorkbook.id]);
                        if(checkIfWbHasBeenDeactivated.length !== 0) {
                            dispatch(updateWorkBookListInStoreAndSideBarIfWbDeleted(currentSelectedWorkbook.id));
                            renderAlert("Workbook deleted by someone, redirecting to My Workbooks ","error",1000)
                            dispatch(navigateToMyWorkbooks(false,navigate));

                        }else{
                      handleEmptySheetList(
                        isEmptySheetList,
                        dispatch,
                        currentSelectedWorkbook,
                        navigate
                      );
                    }
                    }
        
                    if (!sheet) navigate("/home");
        
                    if (callback) callback();
                  }))

        }
        
    } catch (error) {
        console.log("Error in updateWorkbookInStoreAfterSheetNotFound", error);
        
    }

}

export const updateWorkBookListInStoreAndSideBarIfWbDeleted = (wbToRemove) => async (dispatch) => {
    try {
        const { workbookListData,isSharedWorkbook } = store.getState().workbookReducer;
        if (!isSharedWorkbook) {
            const updatedWorkbookListData = workbookListData.filter((wb) => wb.id !== wbToRemove);

            dispatch({
                type: ACTION_TYPES.SET_WORKBOOK_DATA,
                workbookListData: updatedWorkbookListData,
                isSharedWorkbook: false
            })
            dispatch({ type: ACTION_TYPES.SET_WORKSPACE_DATA, rowDataEditor: { action: "deleteWorkbook", workbook: { id: wbToRemove } } })

        }

    } catch (error) {
        console.log("Error in updateWorkBookListInStoreAndSideBarIfWbDeleted", error);

    }
}
  
export const saveWorkbook = (
    newWorkbook,
    currentWorkbook,
    workbookListData,
    currentSelectedWorkbook,
    callbackWhenWorbookIsUpdated,
    isCurrentSelectedWorkbook = true,
) => async (dispatch) => {
    try {
        return new Promise(async (resolve, reject) => {
            const { currentSelectedWorkbook } = store.getState().workbookReducer

            let workbookPayload = { doc: {}, id: null, index: "workbook" };
            if (newWorkbook) {
                workbookPayload.doc.name = newWorkbook.name;
                workbookPayload.id = newWorkbook.id;
            } else if (currentWorkbook) {
                workbookPayload.doc.name = currentWorkbook.doc.name;
                workbookPayload.id = currentWorkbook.id;
            } else if (currentSelectedWorkbook) {
                workbookPayload.doc.name = currentSelectedWorkbook.name;
                workbookPayload.id = currentSelectedWorkbook.id;
            }

            if (currentSelectedWorkbook?.index) {
                workbookPayload.index = currentSelectedWorkbook.index;
            }
            let workbook = newWorkbook ? newWorkbook : workbookPayload;
            
            let body = workbook;
            // let url = !workbook.id ? WORKBOOK_URL +"/save": WORKBOOK_URL +"/"+ workbook.id ;
            let url = !workbook.id ? "/insertDoc" : "/update";
            let response;
            if (!workbook.id) {
                response = await POST(ELASTIC_URL + url, body)
            } else {
                response = await PATCH(ELASTIC_URL + url, body);

            }

            // dispatch({type: ACTION_TYPES.SAVE_WORKBOOK_DATA_SUCCESS, payload: {dataSource: 'elastic', workbookData: response.data, workbookListData, workbook}})
            if (response && (response.error === undefined || response.error.statusCode === undefined) && response) {
                const { isSharedWorkbook, sharedWithMeWorkBooks } = store.getState().workbookReducer;
                let newWorkbookFromDB = response.data;
                
                if (newWorkbookFromDB && newWorkbookFromDB._id) {
                    const newWorkbookObject = { index: newWorkbookFromDB._index, id: newWorkbookFromDB._id, ...workbook.doc }

                    let workbookListCopy = isSharedWorkbook ? [...sharedWithMeWorkBooks] : [...workbookListData];
                    const existingWorkbookIndex = workbookListCopy.findIndex((w) => w.id === newWorkbookFromDB._id);
                    console.log("Checking when it called", existingWorkbookIndex);
                    //for existing workbook
                    if (existingWorkbookIndex !== -1) {

                        await dispatch(handleExistingWorkbookUpdate(
                            workbookListCopy,
                            currentSelectedWorkbook,
                            newWorkbookFromDB,
                            newWorkbookObject,
                            existingWorkbookIndex,
                            isCurrentSelectedWorkbook,
                            callbackWhenWorbookIsUpdated
                        ));
                        return;
                    } else {
                        //for new workbook
                        workbookListCopy.push(newWorkbookFromDB);
                        if (isSharedWorkbook) {
                            workbookListCopy = [...workbookListData]
                            workbookListCopy.push(newWorkbookObject);
                        }
                        if (isCurrentSelectedWorkbook) {
                            await dispatch({ type: ACTION_TYPES.SET_WORKBOOK_DATA, workbookListData: workbookListCopy, selectedWorkbookId: newWorkbookFromDB._id, currentSelectedWorkbook: newWorkbookObject, isSharedWorkbook: false })
                        }
                        else {
                            await dispatch({ type: ACTION_TYPES.SET_WORKBOOK_DATA, workbookListData: workbookListCopy })
                        }
                        // rowDataEditor to update the sidebar 
                        dispatch({ type: ACTION_TYPES.SET_WORKSPACE_DATA, rowDataEditor: { action: "addWorkbook", workbook: newWorkbookObject } })

                        resolve(newWorkbookObject)
                        renderAlert('Workbook added', 'success')
                        return;
                    }
                }
            }
            return;
        })
    } catch (error) {
        console.log("error in saving workbook", error)
        renderAlert('Error in adding workbook', 'error')
    }
}

const cloneSheetFromTemplate = async ({ sheet, newWorkbookId, newLId, userData, template, retainData }) => {
    const isXpad = sheet.sheetType === 'xPad';
    const isGuidelinesSheet = sheet.name?.toLowerCase() === 'guidelines';
    const finalRetainData = isXpad && isGuidelinesSheet ? true : retainData;

    const sheetId = 'sh_' + uuidv4();
    const sheet_identifier = uuidv4();
 
    const clonedRows = (sheet.Rows || []).map(row => {
       // const newRowId = uuidv4();
        const clonedCells = (row.data || []).map(cell => ({
            ...cell,
            cellId: uuidv4()
        }));

        return {
            ...row,
            sheet_id: sheetId,
            data: clonedCells,
        };
    });

    const uniqueColumnId = uuidv4();
    const updatedColumns = (sheet.columns || []).map(originalColumn => {
        const modifiedColumn = { ...originalColumn };
        modifiedColumn.template = true;
        if (typeof modifiedColumn.block === 'string') {
            try {
                const parsedData = JSON.parse(modifiedColumn.block);
                modifiedColumn.block = typeof parsedData === 'object' ? parsedData : null;
            } catch {
                modifiedColumn.block = 'timeseries';
            }
        }
    
        const isRootTimeseriesColumn = modifiedColumn.block?.type === 'timeseries';
        if (isRootTimeseriesColumn) {
            modifiedColumn.colId = uniqueColumnId;
            modifiedColumn.columnElasticid = uniqueColumnId;
        } else if (modifiedColumn.block === 'timeseries') {
            modifiedColumn.parent = uniqueColumnId;
            modifiedColumn.columnElasticid = `${uuidv4()}`;
        } else if (!originalColumn.parent) {
            modifiedColumn.columnElasticid = `${uuidv4()}_es`;
        }
    
        if (typeof modifiedColumn.block === 'object') {
            modifiedColumn.block = JSON.stringify(modifiedColumn.block);
        }
    
        return modifiedColumn;
    });

    const newSheetDoc = {
        index: window.SHEET_INDEX,
        doc: {
            id: sheetId,
            sheet_identifier,
            name: sheet.name,
            sheetType: sheet.sheetType,
            parent: newWorkbookId,
            workbook_id: newWorkbookId,
            workspace_id: "myWorkspace",
            user_id: userData.user_id || userData.email,
            user_email: userData.user_id || userData.email,
            template_id: template.template_id,
            columns: updatedColumns,
            Rows: finalRetainData ? clonedRows : [],
            retainData: finalRetainData,
            globalStyle: sheet.globalStyle || {},
            namedFilters:sheet.namedFilters,
            notes: finalRetainData ? sheet.notes || '' : '',
            templateOwner: template.user_id,
            attachments: finalRetainData ? sheet.attachments || [] : [],
            ...(isXpad && { xPadContent: sheet.xPadContent }),
            ...(sheet?.azureIntegrationInfo && {azureIntegrationInfo:sheet.azureIntegrationInfo})
        }
    };
    const res = await POST(`${ELASTIC_URL}/sheet/insertDoc`, newSheetDoc);
    newSheetDoc.doc.name = res?.data?.sheetName || newSheetDoc.name;
    return newSheetDoc.doc;
};

export const cloneWorkbookFromTemplate = ({
    workbook,
    sheetData,
    template,
    workbookListData,
    retainData,
    callback
}) => async (dispatch, getState) => {
    const { userData } = store.getState().userReducer;
    const { doc: newWorkbook, newLId } = await createNewWorkbookFromTemplate({ workbook, template, userData, workbookListData, retainData });
    let workbookListDataCopy = [...workbookListData]
    workbookListDataCopy.push(newWorkbook)
    dispatch({
        type: ACTION_TYPES.SET_WORKSPACE_DATA,
        rowDataEditor: {
            action: "addWorkbook",
            workbook: newWorkbook
        }
    });
    dispatch({ type: ACTION_TYPES.SET_WORKBOOK_DATA, workbookListData: workbookListDataCopy, selectedWorkbookId: newWorkbook.id, currentSelectedWorkbook: newWorkbook ,isSharedWorkbook:false })
    const createdSheets = [];

    for (const sheet of sheetData) {
        const newSheet = await cloneSheetFromTemplate({
            sheet,
            newWorkbookId: newWorkbook.id,
            newLId,
            userData,
            workspace_id: newWorkbook.workspace_id,
            template,
            retainData
        });

        dispatch({
            type: ACTION_TYPES.SET_WORKSPACE_DATA,
            rowDataEditor: {
                action: 'addSheet',
                sheet: newSheet
            }
        });

        createdSheets.push(newSheet);
    }

    newWorkbook.sheetList = createdSheets;
    dispatch({
        type: ACTION_TYPES.SET_SHEET_DATA, currentSelectedSheet: createdSheets[0],
        sheetData: createdSheets, selectedSheetId: createdSheets[0]?.id, sheetListData: createdSheets
    });

    if (callback) callback(newWorkbook, createdSheets);
};

const createNewWorkbookFromTemplate = async ({ template, userData, workbookListData, retainData }) => {
    const workspace_id = 'myWorkspace';
    const newWorkbookId = 'wb_' + uuidv4();
    const newLId = `${workspace_id}.myWorkbooks.${newWorkbookId}`;
    const workbookName = generateUniqueWorkbookName(template.template_name, workbookListData)

    const newWorkbookDoc = {
        index: 'workbook',
        doc: {
            id: newWorkbookId,
            l_id: newLId,
            name: workbookName,
            parent: "myWorkbooks",
            remote_datasource: 'Elastic',
            shared_with: [],
            user_email: userData.email,
            user_id: userData.email,
            workspace_id,
            template_id: template.template_id,
            templateOwner:template.user_id,
            retainData
        }
    };

    await POST(`${ELASTIC_URL}/insertDoc`, newWorkbookDoc);
    return { doc: newWorkbookDoc.doc, newLId };
};

const generateUniqueWorkbookName = (templateName, workbookList) => {
    const existingNames = new Set(workbookList.map(wb => wb.name));
    let counter = 1;
    let newName;
    while (true) {
        newName = `${templateName}-${counter}`;
        if (!existingNames.has(newName)) {
            return newName;
        }
        counter++;
    }
};

export const createWorkbookHelper = ({ wbId, workspace_id, l_id, parent, name, isWorkbooktemplate, callback, isImported, processedWorksheets }) => async (dispatch) => {
    const { userData } = store.getState().userReducer
    let newWorkbook = {
        "index": "workbook", "doc": {
            "id": wbId,
            "name": name,
            "user_id": userData.user_id || userData.email,
            "user_email": userData.email,
            "shared_with": [],
            "remote_datasource": "Elastic",
            workspace_id,
            l_id,
            parent
        }
    };
    let body = newWorkbook;
    const response = await PATCH(ELASTIC_URL + '/insertDoc', body);
    const newWorkbookObject = { ...newWorkbook.doc }
    dispatch({ type: ACTION_TYPES.SET_WORKSPACE_DATA, rowDataEditor: { action: "addWorkbook", workbook: newWorkbookObject } })

    let sheetName = "Sheet (1)"
    let sheetId = 'sh_' + uuidv4();
    let sheet_l_id = l_id + "." + sheetId;
    let sheetType = "default"
    let createdSheetInfo;

    if (isImported) {
        createdSheetInfo = [];
        for (const sheet of processedWorksheets) {
            const sheetName = sheet.sheetName;
            const sheetId = 'sh_' + uuidv4();
            const sheet_l_id = l_id + '.' + sheetId;
            const sheetType = sheet.sheetType;
            const rows = sheet.rows;
            const columns = sheet.columns.map(item => item.columnForDb);
            const columnNames = sheet.columns.map(item => item.columnName)
            const columnTypes = sheet.columns.map(item => item.columnType)
            const columnGroups = sheet.columnGroups;
            let workbooktemplate = false
            const sheetInfo = await dispatch(createSheetHelperForWorkSpaces({
                sheetName,
                sheetId,
                sheetType,
                workspace_id,
                l_id: sheet_l_id,
                workbook_id: wbId,
                parent: wbId,
                rows,
                columns,
                columnNames,
                isImported,
                columnTypes,
                workbooktemplate,
                newWorkbook_l_id: '',
                callback: (res, sheetInfo) => {
                    createdSheetInfo.push(sheetInfo.doc);
                },
                columnGroups,
                sharedWithMeWorkBooks: '',
                azureIntegrationInfo: sheet.azureIntegrationInfo
            }));

        }
        callback(newWorkbook.doc, createdSheetInfo);
    }
    else {
        await dispatch(createSheetHelperForWorkSpaces({
            sheetName, sheetId, sheetType, workspace_id, l_id: sheet_l_id, workbook_id: wbId, parent: wbId, isWorkbooktemplate, newWorkbook_l_id: l_id, callback: (res, sheetInfo) => {
                createdSheetInfo = sheetInfo.doc
                if (response && response.data) callback(newWorkbook.doc, createdSheetInfo, res)
            }
        }))
    }
}

export const shareWorkbookAccess=async(workbook,sharedWith,viewName,access,callback)=>{
    const handleuser=async(userToReceive)=>{
        let accessObj={}
        let accesses=[]
        const {userData}=store.getState().userReducer
        accessObj.id=userToReceive.email+"_"+workbook.id
        accessObj.user_id=userToReceive.email
        accessObj.entity_id=workbook.id
        accessObj.sender_id = userData.email;
        if(userToReceive.email===userData.email){
            renderAlert("Sheet can't be shared with the same person which is signed In",'error')
            return
        } 
        accessObj.type = workbook.copyOfOriginal?'Template':'Workbook';
        accessObj.compound_object = false;
        accessObj.access_created = new Date(); // Set the timestamp to the current date/time
        accessObj.access_updated = new Date();      
        accessObj.receiver_name=userToReceive.username;  
        accessObj.view=viewName
        let highLevelAccessArr = ["2", "0", "0", "0"];
        if (access.indexOf('admin') !== -1) {
            highLevelAccessArr = ["2", "2", "2", "2"]
            accessObj.Read = "Full"
            accessObj.Write = "Full"
            accessObj.Share = "Full"
            accessObj.Delete = "Full"
            accesses.push('Read', 'Write', 'Share', 'Delete')
            accessObj.admin = true;
        }
        else{
            accessObj.admin = false;
        }    
        if(access.indexOf('read')!=-1) {highLevelAccessArr[0] = "2"; if (!accessObj.Read) accessObj.Read = 'Full'; accesses.push('Read')}
        if(access.indexOf('write')!=-1) {
        highLevelAccessArr[1] = "2";
        highLevelAccessArr[0] = "2"; 
        if (!accessObj.Write) accessObj.Write = 'Full'
        if (!accessObj.Read) accessObj.Read = 'Full'
        accesses.push('Write')
        }
        else {highLevelAccessArr[1] = "0"
        if (!accessObj.Write) accessObj.Write = 'None'
        }
        if(access.indexOf('share')!=-1){ highLevelAccessArr[2] = "2"; if (!accessObj.Share) accessObj.Share = 'Full'; accesses.push('Share')}
        else{ highLevelAccessArr[2] = "0";  if (!accessObj.Share) accessObj.Share = 'None'}
        if(access.indexOf('delete')!=-1) {highLevelAccessArr[3] = "2";  if (!accessObj.Delete) accessObj.Delete = 'Full';else if(accessObj.Delete) highLevelAccessArr[3]='1'; accesses.push('Delete')}
        else {highLevelAccessArr[3] = "0" ; if (!accessObj.Delete) accessObj.Delete = 'None'}
        accessObj.highlevelaccess=highLevelAccessArr.join('')
        const response = await POST(`/access/register`,accessObj);
        if(response.status===201)
        {
            //let accessLevel=(accessObj.Read==='Full' && accessObj.Write==='Full' && accessObj.Delete==='Full' && accessObj.Share==='Full' ) ? 'Full':'Partial'
            let accessLevel = accesses.join(' ')
            const currentAccessInfoById = store.getState().userActivityReducer.accessInfoById
            const currentAccessInfo = store.getState().userActivityReducer.accessInfo
            const updatedAccessInfoById = [...currentAccessInfoById, accessObj]
            const updatedAccessInfo = new Map(currentAccessInfo)
            updatedAccessInfo.set(accessObj.id, accessObj)
            store.dispatch({ type: ACTION_TYPES.SET_USER_ACTIVITY_INFO, accessInfo: updatedAccessInfo, accessInfoById: updatedAccessInfoById })
            callback(accessLevel, userToReceive)
        }
    }

    for(const userToReceive of sharedWith)
    {
        await handleuser(userToReceive);
    }
}

export const shareWorkbookNotification=async(workbook,userToReceive,message,view,accessLevel,sharedByMeNotifications,dispatch,callback)=>{
    try {
        let newNotification={}
        const {userData}=store.getState().userReducer
        newNotification.notification_id=uuidv4()
        newNotification.recipient_id = userToReceive.email;
        newNotification.sender_id = userData.email;
        newNotification.entity_id=workbook.id
        newNotification.receiver_name=userToReceive.username
        if(userToReceive.email===userData.email){
            renderAlert("Workbook can't be shared with the same person which is signed In",'error')
            return
        } 
        newNotification.message = message;
        newNotification.timestamp = new Date(); // Set the timestamp to the current date/time
        newNotification.notification_type = 'Shared';
        newNotification.status = 'Not read';
        newNotification.view = view;
        newNotification.accesslevel = accessLevel;
        let metaData = {
            workbook_id: workbook.id, WorkbookName: workbook.template_id?workbook.templateName:workbook.name, username: userData.name, type: workbook.copyOfOriginal
                ? 'Template' : 'Workbook'
        }
        newNotification.metadata=JSON.stringify(metaData)
        const response = await POST(`/notification/register/`,newNotification);
        if(response.status===201) {    
            let {currentSelectedSheet}=store.getState().sheetReducer;
            let {currentSelectedWorkbook}=store.getState().workbookReducer;

            let sheet_id = '';
            if(currentSelectedSheet.workbook_id === workbook.id){
                sheet_id = currentSelectedSheet.sheet_identifier;
            }else if(workbook.sheetList && workbook.sheetList.length > 0 ){
                sheet_id = workbook.sheetList[0].sheet_identifier
            }
            sendMail({
                username : userToReceive.username,
                email : userToReceive.email
            },{
                username : userData.name,
                email : userData.email
            }, 
            newNotification.entity_id.startsWith("wb_"), 
            {
                sheet_identifier : sheet_id,
                name : view
            },
            newNotification.entity_id.startsWith("wb_") && currentSelectedSheet?.copyOfOriginal && currentSelectedWorkbook?.copyOfOriginal
            )   
            callback("success") 
            sharedByMeNotifications.set(newNotification.notification_id,newNotification)
            let updatedNotifications=new Map(sharedByMeNotifications)
            dispatch({type: ACTION_TYPES.SET_USER_ACTIVITY_INFO,sharedByMeNotifications:updatedNotifications})   
        }
        else{
            callback("error")     
        }
    
} catch (error) {
    callback(error)     
    console.log("error in sharing sheet", error);
}
}

export const setSharedWorkbookInStore = (sharedWithMeWorkBooks) => async(dispatch) =>{
    dispatch({type : ACTION_TYPES.SET_SETSHAREDWITHMEWORKBOOKS , sharedWithMeWorkBooks : sharedWithMeWorkBooks});
}


export const setIsSharedWorkbookAndCurrentSelectedWorkbook = (isSharedWorkbook, currentSelectedWorkbook) => async(dispatch) => {
    dispatch({type : ACTION_TYPES.SET_WORKBOOK_DATA , isSharedWorkbook: isSharedWorkbook, currentSelectedWorkbook: currentSelectedWorkbook});
    
}

export const setIsSharedWorkbookFlag = (isSharedWorkbook) => async(dispatch) => {
    dispatch({type : ACTION_TYPES.SET_WORKBOOK_DATA , isSharedWorkbook: isSharedWorkbook });
}

export const updateWbWhenLogout = async (wb_id, user_email) => {
    try {

        await POST(`${ELASTIC_URL}/workbook/updatewhenlogout`, { id: wb_id, 'user_email': user_email });

    } catch (error) {
        console.log("Error in updateWbWhenLogout", error);
    }
}

export const setIsWorkbookDeleting = (isWorkbookDeleting) => async (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_IS_WORKBOOK_DELETING, isWorkbookDeleting: isWorkbookDeleting })
}